import React from 'react';
import { StyledEngineProvider } from "@mui/system";
import { AuthProvider } from './context/AuthContext';
import { AllocationSetupProvider } from './context/AllocationSetupContext';
import LoadScriptWrapper from './components/LoadScriptWrapper';
import AppContent from './AppContent';

import './App.css';

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <AuthProvider>
        <AllocationSetupProvider>
          <LoadScriptWrapper>
            <AppContent />
          </LoadScriptWrapper>
        </AllocationSetupProvider>
      </AuthProvider>
    </StyledEngineProvider>
  );
}

export default App;
